var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M20.0002 10.2219C20.0002 9.39973 19.9321 8.79973 19.7848 8.17752H10.2041V11.8886H15.8277C15.7144 12.8108 15.1022 14.1997 13.7416 15.133L13.7225 15.2572L16.7517 17.557L16.9616 17.5775C18.889 15.833 20.0002 13.2664 20.0002 10.2219",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_2",
    d: "M10.2027 20C12.9578 20 15.2708 19.1111 16.9602 17.5778L13.7402 15.1332C12.8785 15.7221 11.722 16.1333 10.2027 16.1333C7.5043 16.1333 5.21403 14.3889 4.39761 11.9777L4.27794 11.9877L1.12811 14.3766L1.08691 14.4888C2.76493 17.7555 6.21171 20 10.2027 20Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_3",
    d: "M4.39914 11.9778C4.18372 11.3556 4.05904 10.6889 4.05904 10C4.05904 9.31108 4.18372 8.64444 4.3878 8.02223L4.3821 7.88972L1.19278 5.46246L1.08843 5.5111C0.396838 6.86666 0 8.38891 0 10C0 11.6111 0.396838 13.1333 1.08843 14.4888L4.39914 11.9778",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vector_4",
    d: "M10.2028 3.86663C12.1189 3.86663 13.4114 4.67773 14.1484 5.35555L17.0283 2.59999C15.2596 0.988889 12.9579 0 10.2028 0C6.21174 0 2.76494 2.24442 1.08691 5.51105L4.38629 8.02218C5.21405 5.61109 7.50433 3.86663 10.2028 3.86663",
    fill: "#EB4335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.964166f8edc4626c52a254803b70560a.svg";
export { ForwardRef as ReactComponent };